import styled from "styled-components";

export const SidebarFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions.spacing[2]};
  padding: ${({ theme }) => `${theme.dimensions.spacing[2]} 0 0`};
  width: 100%;
`;

export const SidebarUserButton = styled.button<{ $collapsed: boolean }>`
  align-items: center;
  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.dimensions["border-radius"].md};
  color: ${({ theme }) => theme.colors["grey-700"]};
  cursor: pointer;
  display: flex;
  gap: ${({ theme }) => theme.dimensions.spacing[1]};
  justify-content: ${({ $collapsed }) => ($collapsed ? "center" : "flex-start")};
  min-width: 0;
  padding: ${({ $collapsed, theme }) =>
    $collapsed ? "0" : `0 ${theme.dimensions.spacing[1]}`};
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors["grey-100"]};
  }
`;

export const SidebarAvatar = styled.div<{ $bgColor?: string }>`
  align-items: center;
  background-color: ${({ $bgColor, theme }) => $bgColor ?? theme.colors["green-300"]};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors["white"]};
  display: flex;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  height: ${({ theme }) => theme.dimensions.spacing[4]};
  justify-content: center;
  line-height: 1;
  width: ${({ theme }) => theme.dimensions.spacing[4]};
`;

export const SidebarUserText = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 1.3;
  min-width: 0;

  strong,
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    color: ${({ theme }) => theme.colors["grey-500"]};
  }
`;

export const PoweredByWrapper = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
  width: 100%;
`;

export const ExtPromotorContainer = styled.div`
  display: flex;
  width: 100%;
  flex-shrink: 0;
  justify-content: center;
`;

export const CollapsedExtensionContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const CollapsedExtensionButton = styled.button`
  background: transparent;
  border: none;
  height: ${({ theme }) => theme.dimensions.spacing[4]};
  padding: 0;
  width: ${({ theme }) => theme.dimensions.spacing[4]};
`;

export const CollapsedExtensionIcon = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const ModalContent = styled.div`
  position: absolute;
  left: ${({ theme }) => theme.dimensions.spacing[2]};
  bottom: ${({ theme }) => theme.dimensions.spacing[10]};
`;

export const SidebarMenuUserInfo = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.dimensions.spacing[1]};
`;

export const SidebarMenuEmail = styled.div`
  color: ${({ theme }) => theme.colors["grey-500"]};
  font-size: 12px;
`;

export const SidebarMenuLabelInfo = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.dimensions.spacing[1]};
`;
